export default __webpack_public_path__ + "static/media/Ashley-Milne-Tyte.dda065e6.jpg";